module.exports = __webpack_public_path__ + "img/medical_bricks_2.c2a9eb28.png";